import React from 'react'
import { useAppContext } from '../context/siteMapContext'

interface IPageTitle {
  title: string
}

const PageTitle: React.FC<IPageTitle> = ({ title }) => {
  const { highContrastOn } = useAppContext();

  return (
    <h1 className='text-page-title 2xl:text-page-title-2xl text-page-title-color font-montserrat font-semibold white-space-nowrap'>
      <span className={`${highContrastOn ? 'text-white' : ''}`}>{title}</span>
    </h1>
  )
}

export default PageTitle
